var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links-group"},[_c('div',{staticClass:"links-group__title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.links),function(ref){
var url = ref.url;
var title = ref.title;
return _c('a',{key:url,staticClass:"links-group__link",attrs:{"href":url}},[_c('span',{staticClass:"links-group__link-text"},[_vm._v(_vm._s(title))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }